import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'

import { TokenRepository } from '../token-repository/TokenRepository'
import { Token } from '../types/Token'
import { TokenSymbol } from '../types/TokenSymbol'
import { FilterObjectValues } from '@/utils/types'

export function sortByUsdValue<T extends { token: Token }, K extends keyof FilterObjectValues<T, NormalizedNumber>>(
  a: T,
  b: T,
  key: K,
): number {
  const aUsdValue = a.token.toUSD((a as any)[key])
  const bUsdValue = b.token.toUSD((b as any)[key])
  return aUsdValue.comparedTo(bUsdValue)
}

export function sortByAPY(a: Percentage | undefined, b: Percentage | undefined): number {
  if (!a && !b) {
    return 0
  }
  if (!b) {
    return 1
  }
  if (!a) {
    return -1
  }
  return a.comparedTo(b)
}

export function sortByUsdValueWithUsdsPriority(tokens: Token[], tokenRepository: TokenRepository): Token[] {
  return tokens.sort((a, b) => {
    const aBalance = tokenRepository.findOneBalanceOrZero(a.symbol)
    const bBalance = tokenRepository.findOneBalanceOrZero(b.symbol)
    const usdValueComparison = b.toUSD(bBalance).comparedTo(a.toUSD(aBalance))
    if (usdValueComparison !== 0) return usdValueComparison
    // Prioritize token with USDS symbol
    const usds = tokenRepository.findBySymbol(TokenSymbol('USDS'))
    if (usds) {
      if (a.symbol === usds.symbol) return -1
      if (b.symbol === usds.symbol) return 1
    }
    return 0
  })
}
